import * as React from 'react';
import * as Sentry from '@sentry/react';
import { RouterProvider } from 'react-router';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { router } from './routes';
import { AuthProvider } from './contexts/AuthContext';

function Fallback({ error }: { error: unknown }) {
  return (
    <div style={{ padding: 24, fontFamily: 'Georgia, serif', color: '#2A1A0E' }}>
      <h2>Что-то пошло не так</h2>
      <p style={{ color: '#7A6459' }}>
        Мы уже получили отчёт об ошибке. Попробуй обновить страницу.
      </p>
      {import.meta.env.DEV && (
        <pre style={{ fontSize: 12, background: '#FFF8F0', padding: 12, borderRadius: 8 }}>
          {String(error)}
        </pre>
      )}
    </div>
  );
}

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={Fallback}>
      <AuthProvider>
        <RouterProvider router={router} />
        <Analytics />
        <SpeedInsights />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  );
}
